import { render, staticRenderFns } from "./warranty-detail-paperless.vue?vue&type=template&id=bafeedce&scoped=true&"
import script from "./warranty-detail-paperless.vue?vue&type=script&lang=js&"
export * from "./warranty-detail-paperless.vue?vue&type=script&lang=js&"
import style0 from "./warranty-detail-paperless.vue?vue&type=style&index=0&id=bafeedce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bafeedce",
  null
  
)

export default component.exports